import PropTypes from 'prop-types';

export const propTypes = {
  // openModal prop
  sectionPath: PropTypes.string,
  // Parent prop
  handleEdit: PropTypes.func,
  modalKey: PropTypes.string,
};
